import axios from 'axios'
import {
  map,
  get,
  flatten,
  sortBy,
  find,
  set,
  cloneDeep,
  filter,
  takeRight,
  groupBy,
  intersectionBy,
  chunk,
  forEach,
  isEqual,
} from 'lodash-es'
import { Promise } from 'bluebird'
import moment from 'moment'
import {
  MINGDAO_APP_KEY as appKey,
  MINGDAO_SIGN as sign,
  MINGDAO_API_BASE,
  REFRESH_JU_DANS_WEBHOOK,
  DEFAULT_OWNER_ID,
  WORKSHEETS,
  VIEWS,
  ACCOUNT_FIELDS,
  JU_FIELDS,
  DAN_FIELDS,
} from './constants'

export const getAccountList = () => {
  return axios.post(`${MINGDAO_API_BASE}/getFilterRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.ACCOUNT,
    pageSize: 500,
    pageIndex: 1,
    listType: 1,
    filters: [
      {
        controlId: ACCOUNT_FIELDS.FILTER_FLAG,
        spliceType: 1,
        dataType: 36,
        value: 1,
        filterType: 6, // 不是（不等于）
      },
    ],
  })
}

export const getJuItem = ({ juId }) => {
  return axios.get(`${MINGDAO_API_BASE}/getRowById`, {
    params: {
      appKey,
      sign,
      worksheetId: WORKSHEETS.JU,
      rowId: juId,
    },
  })
}

export const getJuListLatest = () => {
  return axios.post(`${MINGDAO_API_BASE}/getFilterRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.JU,
    pageSize: 20,
    pageIndex: 1,
    listType: 1,
  })
}

export const createJu = ({ name = '七七七七' }) => {
  return axios.post(`${MINGDAO_API_BASE}/addRow`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.JU,
    controls: [
      {
        controlId: JU_FIELDS.NAME,
        value: name,
      },
      {
        controlId: JU_FIELDS.STAGE,
        value: '第一阶段',
      },
      {
        controlId: JU_FIELDS.ROW,
        value: '第一排',
      },
      {
        controlId: 'ownerid',
        value: DEFAULT_OWNER_ID,
      },
    ],
    triggerWorkflow: true,
  })
}

export const getDanList = ({ viewId = VIEWS.DAN_DEFAULT, juId }) => {
  return axios.post(`${MINGDAO_API_BASE}/getFilterRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.DAN,
    viewId,
    pageSize: 500,
    pageIndex: 1,
    listType: 1,
    filters: [
      {
        controlId: DAN_FIELDS.JU_ID,
        spliceType: 1,
        dataType: 29,
        value: juId,
        filterType: 24,
      },
    ],
  })
}

export const createDans = ({ juId, accountList }) => {
  const sortedAccountList = sortBy(accountList, account => Number(get(account, ACCOUNT_FIELDS.LIANHONG)))
  const accountListChunks = chunk(sortedAccountList, 3)

  const chunkRows = map(accountListChunks, (accountListChunk, chunkIndex) => {
    return map(accountListChunk, (account, index) => {
      const accountName = get(account, ACCOUNT_FIELDS.NAME)

      return [
        {
          controlId: DAN_FIELDS.NAME,
          value: `${accountName}__${moment().format('MM-DD/hh:mm')}`,
        },
        {
          controlId: DAN_FIELDS.JU_ID,
          value: juId,
        },
        {
          controlId: DAN_FIELDS.ACCOUNT,
          value: account.rowid,
        },
        {
          controlId: DAN_FIELDS.USER_TOKEN,
          value: get(account, ACCOUNT_FIELDS.USER_TOKEN),
        },
        {
          controlId: DAN_FIELDS.USER_ID,
          value: get(account, ACCOUNT_FIELDS.USER_ID),
        },
        {
          controlId: DAN_FIELDS.LIANHONG,
          value: get(account, ACCOUNT_FIELDS.LIANHONG),
        },
        {
          controlId: DAN_FIELDS.ACCOUNT_ROWID,
          value: account.rowid,
        },
        {
          controlId: DAN_FIELDS.GROUP_INDEX,
          value: chunkIndex + 1,
        },
        {
          controlId: DAN_FIELDS.ROW,
          value: index === 0 ? '第一排' : index === 1 ? '第二排' : '第三排',
          valueType: 1,
        },
        {
          controlId: 'ownerid',
          value: DEFAULT_OWNER_ID,
        },
      ]
    })
  })

  return axios.post(`${MINGDAO_API_BASE}/addRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.DAN,
    rows: flatten(chunkRows),
    triggerWorkflow: false,
  })
}

export const markAwardStaus = ({ dans, isWin }) => {
  const rowIds = map(dans, dan => {
    return get(dan, 'rowid')
  })

  return axios.post(`${MINGDAO_API_BASE}/editRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.DAN,
    rowIds,
    controls: [
      {
        controlId: DAN_FIELDS.AWARD_STATUS,
        value: isWin ? '已中奖' : '未中奖',
      },
    ],
  })
}

export const cancelMarkAward = ({ dans }) => {
  const rowIds = map(dans, dan => {
    return get(dan, 'rowid')
  })

  return axios.post(`${MINGDAO_API_BASE}/editRows`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.DAN,
    rowIds,
    controls: [
      {
        controlId: DAN_FIELDS.AWARD_STATUS,
        value: '',
      },
    ],
  })
}

//
const getAvailableAccountList = accountList => {
  return filter(accountList, accountItem => {
    return get(accountItem, ACCOUNT_FIELDS.IS_POOL) !== '1'
  })
}

//
const getPoolAccountList = accountList => {
  return filter(accountList, accountItem => {
    return get(accountItem, ACCOUNT_FIELDS.IS_POOL) === '1'
  })
}

//
export const getIntersectionPool = (oldAccountList, newAccountList) => {
  const oldPoolAccounts = getPoolAccountList(oldAccountList)
  const oldAvailableAccounts = getAvailableAccountList(oldAccountList)

  const newPoolAccounts = getPoolAccountList(newAccountList)
  const newAvailableAccounts = getAvailableAccountList(newAccountList)

  return [
    intersectionBy(oldPoolAccounts, newAvailableAccounts, 'rowid'),
    intersectionBy(newPoolAccounts, oldAvailableAccounts, 'rowid'),
  ]
}

//
export const getPoolChangedAccountList = (oldAccountList, newAccountList) => {
  return filter(newAccountList, accountItem => {
    const isPool = get(accountItem, ACCOUNT_FIELDS.IS_POOL)
    const oldAccountItem = find(oldAccountList, oldAccountItem => oldAccountItem.rowid === accountItem.rowid)
    const oldIsPool = get(oldAccountItem, ACCOUNT_FIELDS.IS_POOL)

    return isPool !== oldIsPool
  })
}

export const getChangedAccountList = (oldAccountList, newAccountList) => {
  return filter(newAccountList, accountItem => {
    const oldAccountItem = find(oldAccountList, oldAccountItem => oldAccountItem.rowid === accountItem.rowid)

    return !isEqual(accountItem, oldAccountItem)
  })
}

//
export const swapAccountPool = ({ accountList }) => {
  const newAccountList = cloneDeep(accountList)

  const getAvailableAccounts = () => getAvailableAccountList(newAccountList)
  const getPoolAccounts = () => getPoolAccountList(newAccountList)

  // 获取指定连红的备选账号
  const getLianPoolAccounts = lian => {
    const poolAccounts = getPoolAccounts()
    return filter(poolAccounts, account => Number(get(account, ACCOUNT_FIELDS.LIANHONG)) === lian)
  }

  // 从备选中标记到可用列表中
  const removeFrmPool = targetAccounts => {
    forEach(newAccountList, accountItem => {
      if (
        get(accountItem, ACCOUNT_FIELDS.IS_POOL) === '1' &&
        find(targetAccounts, a => a.rowid === accountItem.rowid)
      ) {
        set(accountItem, ACCOUNT_FIELDS.IS_POOL, '0')
      }
    })
  }

  // 从可用列表标记为备选
  const addToPool = targetAccounts => {
    forEach(newAccountList, accountItem => {
      if (
        get(accountItem, ACCOUNT_FIELDS.IS_POOL) !== '1' &&
        find(targetAccounts, a => a.rowid === accountItem.rowid)
      ) {
        set(accountItem, ACCOUNT_FIELDS.IS_POOL, '1')
      }
    })
  }

  const swapWithPool = () => {
    const availableAccounts = getAvailableAccounts()
    const poolAccounts = getPoolAccounts()
    const accountsGroup = groupBy(availableAccounts, ACCOUNT_FIELDS.LIANHONG)

    forEach(Object.keys(accountsGroup), key => {
      const currentLian = Number(key)
      const currentLianAccounts = accountsGroup[key]
      const currentLianCount = currentLianAccounts.length

      if (currentLian > 0) {
        // 新账号替换池子中的账号
        const currentLianPoolAccounts = filter(
          poolAccounts,
          account => Number(get(account, ACCOUNT_FIELDS.LIANHONG)) === currentLian
        )

        const currentLianPoolCount = currentLianPoolAccounts.length

        if (currentLianCount >= currentLianPoolCount) {
          removeFrmPool(currentLianPoolAccounts)
          const toPoolAccounts = takeRight(currentLianAccounts, currentLianPoolCount)
          addToPool(toPoolAccounts)
        }
      }
    })
  }

  const checkWithPool = () => {
    const availableAccounts = getAvailableAccounts()
    const accountsGroup = groupBy(availableAccounts, ACCOUNT_FIELDS.LIANHONG)

    forEach(Object.keys(accountsGroup), key => {
      const currentLian = Number(key)
      const currentLianAccounts = accountsGroup[key]
      const curretnLianCount = currentLianAccounts.length

      const mod = curretnLianCount % 3

      // 遇到 4连红只移出不移入
      if (currentLian >= 4) {
        addToPool(currentLianAccounts)
      }

      if (mod !== 0 && currentLian < 4) {
        const needCount = 3 - mod

        const targetPoolAccounts = getLianPoolAccounts(currentLian)
        const targetPoolCount = targetPoolAccounts.length

        // 找到的数量大于需要的数量
        if (needCount <= targetPoolCount) {
          // 从中取出需要的数量的账号
          const addAccounts = takeRight(targetPoolAccounts, needCount)

          // 从账号列表中标记不为池子中
          removeFrmPool(addAccounts)
        } else {
          // 从 accounts 中取出需要移除数量的账号
          const addPoolAccounts = takeRight(currentLianAccounts, mod)

          // 从账号列表中标记为在池子中
          addToPool(addPoolAccounts)
        }
      }
    })
  }

  const checkAccountCount = () => {
    const updatedAvailableAccounts = getAvailableAccounts()
    const updatedPoolAccounts = getPoolAccounts()

    console.log('updatedAvailableAccounts', updatedAvailableAccounts)
    const diffNum = 81 - updatedAvailableAccounts.length
    if (diffNum > 0) {
      const alternativeAccountList = takeRight(
        filter(updatedPoolAccounts, a => get(a, ACCOUNT_FIELDS.LIANHONG) === '0'),
        diffNum
      )
      removeFrmPool(alternativeAccountList)
    }

    if (diffNum < 0) {
      const alternativeAccountList = takeRight(
        filter(updatedAvailableAccounts, a => get(a, ACCOUNT_FIELDS.LIANHONG) === '0'),
        Math.abs(diffNum)
      )
      addToPool(alternativeAccountList)
    }
  }
  //
  swapWithPool()
  //
  checkWithPool()
  //
  checkAccountCount()

  const [intersectionPools, intersectionAvailables] = getIntersectionPool(accountList, newAccountList)
  const poolChangedAccountList = getPoolChangedAccountList(accountList, newAccountList)

  return { intersectionPools, intersectionAvailables, newAccountList, poolChangedAccountList }
}

export const setAccountSwapPool = newAccountList => {
  return Promise.map(
    newAccountList,
    accountItem => {
      return axios.post(`${MINGDAO_API_BASE}/editRow`, {
        appKey,
        sign,
        worksheetId: WORKSHEETS.ACCOUNT,
        rowId: accountItem.rowid,
        controls: [
          {
            controlId: ACCOUNT_FIELDS.IS_POOL,
            value: get(accountItem, ACCOUNT_FIELDS.IS_POOL),
          },
        ],
      })
    },
    { concurrency: 5 }
  )
}

export const setAccountLianhong = ({ dans, accountList }) => {
  const newAccountList = cloneDeep(accountList)

  // 设置中奖账号连红 + 1
  forEach(dans, dan => {
    const lianhong = Number(get(dan, DAN_FIELDS.LIANHONG))
    const isWin = get(dan, DAN_FIELDS.AWARD_STATUS) === '已中奖'
    const accountRowid = get(dan, DAN_FIELDS.ACCOUNT_ROWID)

    const account = find(newAccountList, account => account.rowid === accountRowid)
    set(account, ACCOUNT_FIELDS.LIANHONG, isWin ? String(lianhong + 1) : '0')
  })

  const changedAccountList = getChangedAccountList(accountList, newAccountList)

  console.log('changedAccountList', changedAccountList)
  return Promise.map(
    changedAccountList,
    accountItem => {
      return axios.post(`${MINGDAO_API_BASE}/editRow`, {
        appKey,
        sign,
        worksheetId: WORKSHEETS.ACCOUNT,
        rowId: accountItem.rowid,
        controls: [
          {
            controlId: ACCOUNT_FIELDS.LIANHONG,
            value: get(accountItem, ACCOUNT_FIELDS.LIANHONG),
          },
        ],
      })
    },
    { concurrency: 5 }
  )
}

export const refreshJuDans = ({ juId }) => {
  axios.post(REFRESH_JU_DANS_WEBHOOK, {
    juId: juId,
  })
}

export const resetAccountLianhong = ({ account }) => {
  return axios.post(`${MINGDAO_API_BASE}/editRow`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.ACCOUNT,
    rowId: account.rowid,
    controls: [
      {
        controlId: ACCOUNT_FIELDS.LIANHONG,
        value: 0,
      },
    ],
  })
}

export const switchBlukOrder = ({ rowId, value }) => {
  return axios.post(`${MINGDAO_API_BASE}/editRow`, {
    appKey,
    sign,
    worksheetId: WORKSHEETS.DAN,
    rowId,
    controls: [
      {
        controlId: DAN_FIELDS.DISABLE_BULK,
        value: value,
      },
    ],
  })
}
